import ErrorIcon from '@mui/icons-material/Error';
import HomeIcon from '@mui/icons-material/Home';
import { Typography, Stack, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ReplayIcon from '@mui/icons-material/Replay';
import { useContext } from 'react';
import { AppContext } from 'src/contexts/AppContext';

const ErrorView = ({ error, onTryAgain }: { error: string; onTryAgain?: () => void }) => {
  const { t } = useTranslation();
  const { pageHeight } = useContext(AppContext);
  return (
    <Stack
      // pageHeight startar på 0 och sätts först av Layouts mät-effekt. Kastas felet
      // INNAN den effekten hunnit köra (kall start, fel i en provider ovanför
      // Layout) renderades rutan med höjd 0 — tom skärm trots att felgränsen
      // fångade. minHeight med 100vh som golv gör felvyn synlig direkt och kan,
      // till skillnad från height, aldrig klippa innehållet.
      minHeight={pageHeight > 0 ? `${pageHeight}px` : '100vh'}
      justifyContent="center"
      alignItems="center"
      direction="column"
      padding={3}
    >
      <ErrorIcon sx={{ fontSize: '6em', color: 'grey.700' }} />
      <Typography variant="h5" component="h1" paragraph>
        {t('Something went wrong!')}
      </Typography>
      <Typography variant="body1" textAlign="center" paragraph>
        {error}
      </Typography>
      {onTryAgain && (
        <Button
          size="large"
          variant="contained"
          color="primary"
          startIcon={<ReplayIcon />}
          sx={{ minWidth: '15em' }}
          onClick={onTryAgain}
        >
          {t('Try again')}
        </Button>
      )}
      <Button
        size="large"
        variant="contained"
        color={onTryAgain ? 'secondary' : 'primary'}
        component={Link}
        to="/"
        startIcon={<HomeIcon />}
        sx={{ minWidth: '15em', marginBottom: '1em', marginTop: '1em' }}
      >
        {t('Go back home')}
      </Button>
    </Stack>
  );
};
export default ErrorView;
